import { createFileRoute } from '@tanstack/react-router'
import { pageMeta } from '~/lib/site/seo'
import { cacheHeaders } from '~/lib/site/cache'
import { getContentPage } from '~/lib/content/content'
import { MarkdownPage } from '~/components/sections/MarkdownPage'

export const Route = createFileRoute('/privacy-policy')({
  loader: () => getContentPage({ data: 'privacy-policy' }),
  headers: () => cacheHeaders.content,
  head: () =>
    pageMeta({
      title: 'Privacy Policy',
      description:
        "Direct Action Everywhere's privacy policy and copyright & trademark information.",
      ogDescription:
        'Our privacy policy and copyright & trademark information.',
    }),
  component: Page,
})

function Page() {
  return <MarkdownPage html={Route.useLoaderData()} />
}
